import { render, staticRenderFns } from "./caseBase.vue?vue&type=template&id=6b17a18c&scoped=true"
import script from "./caseBase.vue?vue&type=script&lang=js"
export * from "./caseBase.vue?vue&type=script&lang=js"
import style0 from "./caseBase.vue?vue&type=style&index=0&id=6b17a18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17a18c",
  null
  
)

export default component.exports